import React from "react";
import Seo from "../components/seo";
import useIsInViewport from "../hooks/useIsInViewport";
import { Link } from "gatsby";
// import { HashLink } from "react-router-hash-link";

/* START: images import */
import marticka from "../img/approach/marticka.jpg";
import standards from "../img/approach/standards.jpg";
import code from "../img/approach/code.jpg";
/* END: images import */

const Intro = ({ setObserverRef }) => (
    <div className="article" id="how" ref={setObserverRef} data-observer={0}>
        <h2 className="line sm animate-1">Skill-up or partner-up</h2>
        <div>
            <blockquote className="desktop noq animate-2">
                <p>Battle-tested foundations reduce cost, so we can focus on the custom features your business truly needs.</p>
            </blockquote>
        </div>
        <article>
            <p className="animate-3">
            We deliver focused expertise in a few core areas and bring ready-made business platforms that give you exceptional freedom to customize at an unmatched price point. By building on battle-tested components, we lower development costs and put more value into the features that make your business unique.{" "}
            </p>
            {/* <h3 className="animate-4">We work the way you work</h3>
            <p className="animate-5">
            Code 8 has evolved as a company to be adaptive and flexible so we can fit with your team. We want to help you make the right technical choices and can consult with you to arrive at the best solution. We also want to help support your team and fill your resource gaps.
            </p> */}
            <h3 className="animate-4">Our family silver</h3>
                <p className="animate-5"><strong>Shop8</strong> is our e-commerce platform that supports multiple countries, portfolios, currencies, and third-party integrations. It is highly customizable and scales with your catalog and operations.</p>
                <p className="animate-6"><strong>Admin8</strong> is a modular CMS with a powerful page builder. Layouts are composed of interchangeable UI blocks. GraphQL and REST APIs can power websites, blogs, or mobile apps.</p>
                <p className="animate-7"><strong>Model8</strong> is our UI system for building complex administrative platforms, proven across robust solutions including inventory management, real estate, and legal or debt-recovery systems.</p>
        </article>
    </div>
);

const Extending = ({ setObserverRef }) => (
    <div ref={setObserverRef} data-observer={1}>
        <article className="article animate-1" id="extending">
            <h2 className="line animate-2">Extending your team</h2>
            <p className="animate-3">
            Clients value a dedicated developer who knows the project inside out, so we aim to provide that. We also share knowledge across the team, so if your primary contact is unavailable, someone fully briefed can step in without delay.
            </p>
        </article>

        <article id="working" className="clearfix animate-4">
            <article className="article animate-5">
                <h3 className="animate-6">Working with developers</h3>
                <p className="animate-7">For tech teams that need front-end support, we integrate smoothly into your sprint cycles. </p>
            </article>
            <article className="article animate-5">
                <h3 className="animate-6">Working with designers</h3>
                <p className="animate-7">We make sure the details in your designs carry through to the final build.</p>
            </article>
        </article>
    </div>
);

const Planning = ({ setObserverRef }) => (
    <article className="article" id="planning" ref={setObserverRef} data-observer={2}>
        <h2 className="line sm animate-1">Fail to plan, plan to&nbsp;fail!</h2>
        <img className="animate-5" src={marticka} alt="Marticka.cz" />
        <p className="animate-2">
            We like to think ahead. We prefer to get things right from the start, and we have often helped clients untangle issues from projects built elsewhere. That is why we work with you to scope properly from day one. We offer a broad range of services, but we are happy to deliver only the part you need, whether that is a pure HTML front end or a full CMS build.
        </p>
        <h3 className="animate-3">Budgeting</h3>
        <p className="animate-4">
            We can work to pre-defined budgets, or for ongoing clients we track time using our own tool,{" "}
            <a href="https://www.marticka.cz/" target="_blank" rel="noopener noreferrer">
                Marticka
            </a>
            . At the end of each month, we provide a clear breakdown of the hours spent across each project.
        </p>
    </article>
);

const Standards = ({ setObserverRef }) => (
    <article className="article" id="standards" ref={setObserverRef} data-observer={3}>
        <h2 className="line sm animate-1">AI-powered delivery, <br/>grounded in experience.</h2>
        <img className="animate-2" src={standards} alt="standards" />
        <p className="animate-3">
        We combine deep, hands-on experience with the latest AI models to deliver dependable engineering and rapid insight. Our approach does not replace expertise; it strengthens it. AI accelerates analysis, explores options, and surfaces patterns, while experienced engineers guide decisions and validate outcomes. This balance helps us move faster early on, uncover opportunities sooner, and reduce trial and error without compromising quality or control.
<br /><br />
In practice, this means faster discovery, better-informed decisions, and solutions tailored to real needs rather than assumptions. By grounding AI capabilities in real-world delivery, we ensure what we build is innovative, practical, maintainable, and ready for production. For clients, that translates into quicker progress, clearer direction, and outcomes that hold up beyond initial delivery.
        </p>
    </article>
);

const Code = ({ setObserverRef }) => (
    <article className="article" id="code" ref={setObserverRef} data-observer={4}>
        <h2 className="line sm animate-1">Quality is built in, not bolted on.</h2>
        <img className="animate-5" src={code} alt="Code" />
        <p className="animate-2">
        We approach development with a focus on clarity, maintainability, and real user value. Systems are built as modular components that evolve without unnecessary complexity. We combine experienced engineering with AI-assisted workflows to move faster while keeping control over quality and design. The result is solutions that are predictable, easy to understand, and simple to extend.
        </p>
        <p className="animate-3">
        Testing is part of how we build, not something added later. We use automated tests and practical validation to ensure features work in real scenarios. This reduces regressions, improves reliability, and makes changes safer. For clients, it means more stable releases and lower long-term costs, while giving us confidence in every deployment.
        </p>
    </article>
);

const Experience = ({ setObserverRef }) => (
    <section ref={setObserverRef} data-observer={5}>
        <article className="article" id="experience">
            <p className="animate-3">
                <Link to="/about/">Who are we?</Link>
            </p>
        </article>
    </section >
);

const Approach = () => {
    const { setRef } = useIsInViewport();
    return (
        <div>
            <Seo title="Approach" />
            <Intro setObserverRef={setRef} />
            <Extending setObserverRef={setRef} />
            <section className="halfContentSection">
                <Code setObserverRef={setRef} />
                <Standards setObserverRef={setRef} />
                <Planning setObserverRef={setRef} />
            </section>
            <Experience setObserverRef={setRef} />
        </div>
    );
};
export default Approach;
